import * as React from "react";
import { Gray100 } from "@traceair/tds";
import { forceRenderStyles, style } from "typestyle";
import Coordinates from "./Coordinates";

const coordinatesStyle = style({
  padding: "0 12px 12px 12px",
});

const closeIconStyle = style({
  cursor: "pointer",
  position: "absolute",
  top: "8px",
  right: "12px",
});

const gcpStatusStyle = style({ color: Gray100 });

const headerTitleStyle = style({
  fontFamily: "Inter Variable",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "16px",
});

const headerStyle = style({
  padding: "8px 12px",
  height: "40px",
  boxSizing: "border-box",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const popupStyle = style({
  width: "244px",
});

interface ICoordinatesFlightMarkerPopupContent {
  name: string;
  coordinates: {
    lat: number;
    lng: number;
    alt: number;
  };
  closePopup: () => void;
  updatePopupLayout?: () => void;
}

export default class CoordinatesFlightMarkerPopupContent extends React.Component<ICoordinatesFlightMarkerPopupContent> {
  public componentDidMount() {
    forceRenderStyles();
    if (this.props.updatePopupLayout) {
      this.props.updatePopupLayout();
    }
  }

  public render() {
    const { name, closePopup } = this.props;

    return (
      <div className={popupStyle}>
        <div className={headerStyle}>
          <span className={headerTitleStyle}>
            <span>{name}, </span>
            <span className={gcpStatusStyle}>Installed</span>
          </span>
          <CloseIcon className={closeIconStyle} onClick={closePopup} />
        </div>
        <Coordinates
          lat={this.props.coordinates.lat}
          lng={this.props.coordinates.lng}
          alt={this.props.coordinates.alt}
          className={coordinatesStyle}
        />
      </div>
    );
  }
}

const CloseIcon = ({
  className,
  onClick,
}: {
  className: string;
  onClick: () => void;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={[
        "M6.11612 7.88388C5.62796 7.39573 5.62796 6.60427 6.11612 6.11612C6.60427 5.62796 7.39573 5.62796",
        "7.88388 6.11612L12 10.2322L16.1161 6.11612C16.6043 5.62796 17.3957 5.62796 17.8839 6.11612C18.372",
        "6.60427 18.372 7.39573 17.8839 7.88388L13.7678 12L17.8839 16.1161C18.372 16.6043 18.372 17.3957",
        "17.8839 17.8839C17.3957 18.372 16.6043 18.372 16.1161 17.8839L12 13.7678L7.88388 17.8839C7.39573",
        "18.372 6.60427 18.372 6.11612 17.8839C5.62796 17.3957 5.62796 16.6043 6.11612 16.1161L10.2322",
        "12L6.11612 7.88388Z",
      ].join(" ")}
      fill=" black"
    />
  </svg>
);
